import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=b216a65a&scoped=true"
import script from "./AccordionItem.js?vue&type=script&lang=js&external"
export * from "./AccordionItem.js?vue&type=script&lang=js&external"
import style0 from "./AccordionItem.scss?vue&type=style&index=0&id=b216a65a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b216a65a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default,HotIcon: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Icon/Icon.vue').default})
